(function () {
  'use strict';
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    var summary = root.querySelector('[data-review-summary]');
    var badge = document.querySelector('[data-review-link]');
    if (badge && summary) {
      badge.hidden = false;
      badge.querySelector('[data-review-link-label]').textContent = summary.dataset.average + ' / 5 · ' + summary.dataset.total + (root.dataset.demo === 'true' ? ' sample reviews' : ' published ratings');
    } else if (badge) badge.hidden = true;
    root.querySelectorAll('[data-review-write]').forEach(function (button) {
      button.addEventListener('click', function () {
        var panel = root.querySelector('.review-form details');
        if (panel) { panel.open = true; panel.querySelector('input:not([type="hidden"])')?.focus({preventScroll: true}); }
      });
    });
    if (root.dataset.demo === 'true') {
      var form = root.querySelector('.review-form');
      var submit = root.querySelector('[data-demo-submit]');
      if (submit && form) {
        submit.disabled = false;
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          root.querySelector('[data-demo-feedback]').textContent = 'Demo preview complete. Nothing was sent or published.';
        });
      }
    }
    var list = root.querySelector('[data-review-list]');
    if (!list) return;
    var original = Array.from(list.querySelectorAll('[data-review-row]'));
    var rating = root.querySelector('[data-review-rating]');
    var sort = root.querySelector('[data-review-sort]');
    var more = root.querySelector('[data-review-more]');
    var count = root.querySelector('[data-review-count]');
    var empty = root.querySelector('[data-review-empty]');
    var limit = 4;
    root.querySelector('[data-review-controls]').hidden = false;
    function render() {
      var matches = original.filter(function (row) { return rating.value === 'all' || row.dataset.rating === rating.value; });
      if (sort.value !== 'featured') matches.sort(function (a, b) {
        var aRating = Number(a.dataset.rating), bRating = Number(b.dataset.rating);
        if (!aRating) return 1; if (!bRating) return -1;
        return sort.value === 'high' ? bRating - aRating : aRating - bRating;
      });
      original.forEach(function (row) { row.hidden = true; });
      matches.forEach(function (row, index) { list.appendChild(row); row.hidden = index >= limit; });
      count.textContent = matches.length ? window.Nutritia.t('reviews_showing', 'Showing {n} of {total} reviews', {n: Math.min(limit, matches.length), total: matches.length}) : window.Nutritia.t('reviews_zero', '0 reviews');
      empty.hidden = matches.length !== 0;
      more.hidden = matches.length <= limit;
    }
    [rating, sort].forEach(function (control) { control.addEventListener('change', function () { limit = 4; render(); }); });
    more.addEventListener('click', function () { limit += 4; render(); });
    render();
  }
  document.querySelectorAll('[data-customer-reviews]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-customer-reviews]').forEach(init);
  });
})();
